import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import Axios from './api/axios'
import { constantRouterMap } from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/base.css'
import '../static/css/common.css'
import 'iview/dist/styles/iview.css' //iview 样式
import 'babel-polyfill'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
// 自定义弹窗
import Toaste from './components/toast/main'
Vue.prototype.$tomo = Toaste
import {
  Message,
  Radio,
  Button,
  Table,
  Col,
  Row,
  Input,
  Form,
  FormItem,
  Menu,
  MenuItem,
  Submenu,
  Select,
  Option,
  Progress,
  Carousel,
  CarouselItem,
  Icon,
  Page,
  DatePicker,
  Modal,
  Tabs,
  TabPane,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Upload,
  Spin,
  InputNumber,
  Switch,
  Card
} from 'iview'   //按需引用iview



Vue.component('Radio', Radio);
Vue.component('Button', Button);
Vue.component('Table', Table);
Vue.component('Col', Col);
Vue.component('Row', Row);
Vue.component('Input', Input);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Menu', Menu);
Vue.component('MenuItem', MenuItem);
Vue.component('Submenu', Submenu);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Progress', Progress);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
Vue.component('Icon', Icon);
Vue.component('Page', Page);
Vue.component('DatePicker', DatePicker);
Vue.component('Modal', Modal);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Upload', Upload);
Vue.component('Spin', Spin);
Vue.component('InputNumber', InputNumber);
Vue.component('i-switch', Switch);
Vue.component('Card', Card);


Vue.config.productionTip = false;
Vue.use(router);
Vue.prototype.$axios = Axios;
Vue.prototype.$Message = Message;

function getAppName(params) {
  return new Promise((resolve, reject) => {
    let param = {
      action: 'queryAppManageLast',
      appId: params.appid || params.appId,
      region: ''
    }
    if (params.domain) {
      let domain = params.domain;
      param = {
        action: 'queryOneApp',
        domain: domain,
      }
    }
    Axios.getNoSign(param).then(res => {
      if (res.err === 0) {
        resolve(res);
      } else {
        reject(err)
      }
    }).catch(err => {
      reject(err)
    })
  })
}
router.beforeEach((to, from, next) => {
  const [path, queryParamsStr] = to.fullPath.split("?");
  const queryParams = new URLSearchParams(queryParamsStr);
  if (to.path === '/webDownload' || to.path === '/appDownload' || to.path === '/scanQRCodes' || to.path === '/electronicManual') {
    next()
  } else if (to.path.includes('/applist')) {
    if (to.path === '/applist' && Object.keys(to.query).length > 0) {
      let appId = to.query.appid || to.query.appId;
      let domain = to.query.domain;
      let i18n = to.query.i18n;
      if (appId) {
        getAppName(to.query)
          .then(res => {
            next({
              name: 'download',
              params: {
                appName: res.dat.english
              },
              query: {
                appId: appId
              }
            });
          })
          .catch((err) => {
            next(
              {
                name: 'download',
                params: {
                  appName: appId
                }
              },
            )
          })
      }
      if (domain) {
        getAppName(to.query)
          .then(res => {
            next({
              name: 'download',
              params: {
                appName: res.dat.english
              },
              query: {
                domain,
                i18n
              }
            });
          })
          .catch((err) => {
            next(
              {
                name: 'download',
                params: {
                  appName: domain
                }
              },
            );
          })
      }
    } else {
      next()
    }
    return;
  } else if (path === '/#/webDownload') {
    const domain = queryParams.get('domain');
    const i18n = queryParams.get('i18n');
    next({ path: '/webDownload', query: { domain, i18n } });
    return;
  } else if (path === '/#/appDownload') {
    const appId = queryParams.get('appId');
    next({ path: '/appDownload', query: { appId } });
    return;
  }
  else if (sessionStorage.getItem('role')) { //判断是否存在token(已登录)
    if (to.path === '/login') { //已登录状态下输入登录路径返回主页
      // next({path: '/appidList'})
      next()
    } else if (to.path === '/') { //重定向
      next()
    } else {
      if (store.getters.newrouter.length !== 0) {
        next()
      } else {
        let newrouter = null;
        //      if (store.getters.role === 0) { //判断是否为管理员权限
        //        newrouter = constantRouterMap;
        //      } else {
        //返回true显示菜单，返回false隐藏
        let newchildren = constantRouterMap[0].children.filter((route, index) => {
          if (route.meta) {
            if (route.meta.role[0] == sessionStorage.getItem('role') || route.meta.role === undefined) {
              return true
            }
            return false
          }
          else {
            return true
          }
        });
        newrouter = constantRouterMap;
        newrouter[0].children = newchildren;
        //      }
        // console.log(newrouter,"newrouter")


        router.options.routes = newrouter;
        store.dispatch('Roles', newrouter).then(res => {
          next({ ...to })
        })
      }
    }
  } else {   // 未登录
    if (['/login'].indexOf(to.path) !== -1) {
      next()
    } else {
      // next()
      next('/login');
    }
  }
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js